import { View } from 'backbone';
import contentTemplate from 'behaviors/active-behaviors.ejs';
import listService      from 'ListService.js';
import pageUtil from 'util/ThumbPageListUtil.js';
import pageSyncService from 'PageSyncService';
import focusController  from 'FocusController';
import util from 'util/Util.js';

class ActiveBehaviors extends View {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';
        
        this.events = {
            'click  #activeBehaviorsButton': 'openBehaviorsList',
            'click  #close-behavior': 'closeBehaviorEv',
            'click .close-behaviors': 'closeAllBehaviors'
        };

        if(listService.currentBehaviorInstanceId){
            this.breadcrumbs = this.getBreadcrumbs(listService.currentBehaviorInstanceId, true);
        }

        return this;
    }

    closeBehaviorEv(ev){
        const id = ev.currentTarget.dataset.id;
        this.closeBehavior(id);        
        $('.behaviors-list div[data-id=' + id + ']').remove();

        if(listService.activeBehaviorInstances.size === 1){ //If there are no more behaviors except the current one
           this.closeBehaviorsList();
        } 
        
        return false;
    }

    closeAllBehaviors(){
        const self = this;

        $(".behavior-item").each((i,item)=>{
            const id = item.dataset.id;
            self.closeBehavior(id);        
        });

        self.closeBehavior(listService.currentBehaviorInstanceId); //close also the current one
        listService.currentBehaviorInstanceId = undefined;
        listService.orderedActiveBehaviors = [];

        Backbone.history.loadUrl('behaviors'); //Reload behaviors
    }

    closeBehavior(id){
        const behavior = listService.getBehaviorInstance(id);
        behavior.set("open", false, {silent:true});
        
        const index = listService.orderedActiveBehaviors.findIndex((item)=>{
            return item.id === id;
        });   
        listService.orderedActiveBehaviors.splice(index, 1);
    }

    getBreadcrumbs(behID, createLink){

        const behavior = listService.getBehaviorInstance( behID );
        let behaviorName = behavior.get("text");
        const ownerId = behavior.get("ownerId");
        const pageId = behavior.get("pageId")
 
        let ownerName = behavior.get("owner");
        let parent = listService.getParentNameOfObject(ownerId);
        let breadcrumbs = "";
        let type = "object";

        if(parent !== "Form" && parent !== "Report"){

            if(createLink){
                parent = `<a class="behaviorLinkToDesigner" data-type="page" data-pageid="${pageId}">${parent}</a>`
            }

            breadcrumbs = parent === "Form" ? "App" : parent;
            breadcrumbs += " > ";
        }  
        else{
            type = "page";
        }
        
        if(ownerName !== "Form" && ownerName !== "Report"){

            if(createLink){
                ownerName = `<a class="behaviorLinkToDesigner" data-type="${type}" data-pageid="${pageId}" data-id="${ownerId}">${ownerName}</a>`
            }

            breadcrumbs += ownerName;
            breadcrumbs += " > ";
        }        

        breadcrumbs += behaviorName;

        breadcrumbs = util.sanitizeHTML(breadcrumbs,false,'',false)

        return breadcrumbs;
    }

    buildActiveBehaviorList(){

        let activeBehaviors = "";
        const self = this;
        

        $(".behavior-item").remove();

        const buildList = (item) => {
            if (item.id !== listService.currentBehaviorInstanceId) {
               
                let behaviorHTML = `<div class="behavior-item" data-id="${item.id}" data-behaviorKey="${item.behaviorKey}" data-ownerId="${item.ownerId}">
                                <div class="close-icon">
                                    <a href="#" id='close-behavior' title="Close Behavior" data-id="${item.id}">
                                        <img src="${require('editor/icons/command_close.png')}" width="12"/>
                                    </a>
                                </div> 
                                <div class="behavior-name">${item.name}</div>
                                <div class="behavior-breadcrumb">${item.breadcrumbs}</div>
                            </div> `
                activeBehaviors = behaviorHTML + activeBehaviors; //Append in reverse to show the last opened behavior at the top of the list
            }
        }

        listService.orderedActiveBehaviors.forEach(buildList);

        $(".behaviors-list").append(activeBehaviors);
        $(".behavior-item").each((i,item)=>{
            $(item).off().on("click", (ev)=>{

                if(ev.target.tagName !== "IMG"){//check it is not the close icon
                    const data = ev.currentTarget.dataset;
                    pageUtil.selectBehaviorInstance('', '', data.ownerid, data.behaviorkey);
                    self.moveBehaviorToTop(data.id);
                }                
            });
        });
    }

    moveBehaviorToTop(id){
        const index = listService.orderedActiveBehaviors.findIndex((item)=>{
            return item.id === id;
        });
       
        const behavior = listService.orderedActiveBehaviors[index];
        listService.orderedActiveBehaviors.splice(index, 1);
        listService.orderedActiveBehaviors.push(behavior);
    }


    getAllActiveBehaviors(){
        const self = this;
        
        const activeBehaviorsList = (behavior, i) => {
            const id = behavior.get('id');
            const behExists = listService.orderedActiveBehaviors.some((instance)=>{
                return instance.id === id;
            })

            if(!behExists){
                const  name = behavior.get('text'),
                ownerId = behavior.get('ownerId'),
                behaviorKey = behavior.get('behaviorKey');

                listService.orderedActiveBehaviors.push(
                    {id, name, ownerId, behaviorKey, breadcrumbs:self.getBreadcrumbs(id)}
                );
            }
        };

        if(listService.activeBehaviorInstances.size > listService.orderedActiveBehaviors.length){
            listService.activeBehaviorInstances.forEach(activeBehaviorsList);
        }

        console.log(listService.orderedActiveBehaviors);
    }

    closeBehaviorsList(){
        const activeButton = $(".activeBehaviors");
        const behaviorsList = $(".behaviors-list");

        activeButton.removeClass("active");
        behaviorsList.hide();    
        
        if(listService.activeBehaviorInstances.size > 1){ //If there are more behaviors than the current one
            $("#activeBehaviorsButton").show();
        }    
        else{
            $("#activeBehaviorsButton").hide();
        }   
    }

    openBehaviorsList(ev){

        const activeButton = $(ev.currentTarget);
        const behaviorsList = $(".behaviors-list");

        if(!activeButton.hasClass('active')){
            
            this.getAllActiveBehaviors();
            this.buildActiveBehaviorList();
            activeButton.addClass("active");
            behaviorsList.show().trigger("focus");

             //Event to hide behaviors list on click
             behaviorsList.off().on("blur", (ev)=> {
                if(!ev.relatedTarget || ev.relatedTarget.id !== "close-behavior"){
                    activeButton.removeClass("active");
                    behaviorsList.hide();                
                }
                behaviorsList.trigger("focus");
            });
        }
    }

    bindEvents(){

        $(".behaviorLinkToDesigner").off().on("click", (ev)=>{
            ev.preventDefault();

            const data = ev.currentTarget.dataset;
            const id = data.id;
            const pageId = data.pageid;

            //Change first to designer view
            $(".layout-switch").trigger("click");
            pageSyncService.displayPage(pageId);

            if(data.type === "object"){
                setTimeout(() => {  //wait for page to open first
                    focusController.toggleOneSelection(id);
                }, 250);                
            }

            return false;
        });
    }


    render() {
        this.$el.append(this.template( this.model.toJSON()));
        this.delegateEvents();   

        if (listService.currentBehaviorInstanceId) {
            if (listService.activeBehaviorInstances.size > 1) { //If there are more behaviors than the current one
                $("#activeBehaviorsButton").show();
            }
            else {
                $("#activeBehaviorsButton").hide();
            }

            $(".current-behavior").html(this.breadcrumbs, true);
            this.bindEvents();
        }

        return this;
    }

}

export default ActiveBehaviors;